import React, { useState, useEffect } from 'react';
import { PricingTiersTab } from './components/PricingTiersTab';
import { WorkspacePricingTab } from './components/WorkspacePricingTab';

export const PricingPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'tiers' | 'workspaces'>('tiers');

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Pricing Management</h1>
          <p className="mt-2 text-sm text-gray-600">
            Manage pricing tiers and workspace-specific pricing overrides
          </p>
        </div>

        {/* Tabs */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab('tiers')}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'tiers'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Pricing Tiers
            </button>
            <button
              onClick={() => setActiveTab('workspaces')}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'workspaces'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Workspace Pricing
            </button>
          </nav>
        </div>

        {/* Tab Content */}
        <div>
          {activeTab === 'tiers' && <PricingTiersTab />}
          {activeTab === 'workspaces' && <WorkspacePricingTab />}
        </div>
      </div>
    </div>
  );
};
